/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';

import { Operations, Payload } from '@tivocorp/tivo-webapp-loggers';

import { DEFAULT_SYSTEM_INFO_LOGGING_INTERVAL } from '../../config';
import { DebugScreenController } from '../../core/debugscreen';
import { SystemInfo } from '../../core/device';

const SystemInfoEvent: FunctionComponent = (): JSX.Element => {
    const oSystemInfo = new SystemInfo();

    const logSystemInfo = () => {
        oSystemInfo.getSystemInfo().then((response: any) => {
            let payload = response?.systemInfo ?? {};
            if (window?.performance) {
                const {
                    memory: { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize },
                }: any = window.performance;
                payload = { ...payload, jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize };
            }
            Operations.logSystemMemoryInfo(new Payload({ ...payload }));
            DebugScreenController.getInstance().setSystemMemoryInfo(payload);
        });
    };

    useEffect(() => {
        const systemLogIntervalId = setInterval(
            logSystemInfo,
            DEFAULT_SYSTEM_INFO_LOGGING_INTERVAL,
        );

        return () => {
            clearInterval(systemLogIntervalId);
        };
    }, []);

    return <></>;
};

export default SystemInfoEvent;
